import React from "react";

/** The label pinned above a reference line in the traffic chart; clickable when `onSelect` is set. */
export default function EventMarker({ viewBox, text, color, row, emphasized, active = false, ariaLabel, onSelect }) {
    const x = viewBox?.x ?? 0;
    const y = (viewBox?.y ?? 0) - 38 + row * 18;
    const width = text.length * 6 + 14;
    const filled = active || emphasized;
    const interactive = !!onSelect;

    return (
        <g
            transform={`translate(${x}, ${y})`}
            style={{ pointerEvents: interactive ? "all" : "none", cursor: interactive ? "pointer" : "default", outline: "none" }}
            role={interactive ? "button" : undefined}
            tabIndex={interactive ? 0 : undefined}
            aria-label={ariaLabel}
            aria-pressed={interactive ? active : undefined}
            onClick={(event) => {
                if (!onSelect) return;
                event.stopPropagation();
                onSelect();
            }}
            onKeyDown={(event) => {
                if (onSelect && (event.key === "Enter" || event.key === " ")) {
                    event.preventDefault();
                    onSelect();
                }
            }}
        >
            {active && <rect x={-width / 2 - 3} y={-3} width={width + 6} height={22} rx={6} fill="none" stroke={color} strokeOpacity={0.35} strokeWidth={2} />}
            <rect x={-width / 2} y={0} width={width} height={16} rx={4} fill={filled ? color : "#FFFFFF"} stroke={color} strokeWidth={1} />
            <text x={0} y={11.5} textAnchor="middle" fontSize={10.5} fontWeight={600} fill={filled ? "#FFFFFF" : color}>{text}</text>
        </g>
    );
}
